var $ = jQuery.noConflict();

$(document).ready(function () {
    function pageHeaderSpacer() {
        const pageheaderHeight = $('.page-header').outerHeight();

        $('body').css('padding-top', pageheaderHeight);
        $('.c-share').css('top', pageheaderHeight + 30);

        $('.nav-sidemenu').css('top', pageheaderHeight);
        if ($(window).outerWidth() >= 992) {
            $('.nav-sidemenu').css('top', pageheaderHeight);
        }
    }

    pageHeaderSpacer();
    $(window).resize(pageHeaderSpacer);
});


// header icon search - focus on input
$('.search-results__search .search-form__input').on('click', function () {
    $('.page-header__top .search__content').removeClass('active');
});
$(document).on('click', 'body', function () {
    if ($('.search__button').hasClass('active')) {
        $('.page-header__top input.search-form__input').focus();
    }
});


// header hamburger mobile menu open
$('.page-header__hamburger--mobile .hamburger').on('click', function (e) {
    $(this).toggleClass('is-active');
    $('body').toggleClass('body-blocked nav-mobile--open');
})


// sidemenu open - on desktop
$('.page-header__hamburger--sidemenu .hamburger').on('click', function (e) {
    $(this).toggleClass('is-active');
    $('.nav-sidemenu').toggleClass('active');
})

// mobile menu - under 992px - dropdown on click
// dedicated for mobile - don't exist on desktop
const mobileDropdown = $('.nav-mobile li.menu-item-has-children');
mobileDropdown.on('click', function (e) {
    if ($(window).outerWidth() <= 992) {
        mobileDropdown.not(this).each(function () {
            $(this).removeClass('open');
        });
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
        } else {
            $(this).addClass('open');
        }
    }
});

// sidemenu - desktop - dropdown on click
// dedicated for desktop - don't exist on mobile
const sidemenuDropdown0 = $('.nav-sidemenu li.menu-item-has-children[data-depth="0"]');
const sidemenuDropdown1 = $('.nav-sidemenu li.menu-item-has-children[data-depth="1"]');

sidemenuDropdown0.on('click', function () {
    const isOpen = $(this).hasClass('open');
    const hasClassOpenChild = $(this).hasClass('open-child');
    const menuChildrenOpen = $(this).find('li.menu-item-has-children[data-depth="1"].open').length > 0;

    if (isOpen && !hasClassOpenChild && !menuChildrenOpen) {
        $(this).removeClass('open');
        $(this).find('> ul.sub-menu').slideUp(300);
    } else {
        $(this).addClass('open');
        $(this).find('> ul.sub-menu').slideDown(300);
    }
});

sidemenuDropdown1.on('click', function () {
    const isOpen = $(this).hasClass('open');
    const menuParent = $(this).closest('li.menu-item-has-children[data-depth="0"]');

    if (isOpen) {
        $(this).removeClass('open');
        $(this).find('> ul.sub-menu').slideUp(300);
        setTimeout(function () {
            menuParent.removeClass('open-child');
        }, 200);
    } else {
        $(this).addClass('open');
        $(this).find('> ul.sub-menu').slideDown(300);
        menuParent.addClass('open-child');
    }
});
